// extracted by mini-css-extract-plugin
export default {"root":"ExternalLink-root-37cd0cd222e0efb1ec3c174368b58612"};